import styled from '@emotion/styled';

export const GalleryWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  list-style: none;
  margin-left: auto;
  margin-right: auto;
`;
